"use client"

import { useState } from "react"
import { useAuthContext } from "@/app/providers/AuthProviders"
// import { useSSEContext } from "@/app/providers/SSEProvider"
import { useMutationSignIn } from "@/entities/user/hooks/useSignIn"
import { CustomButton, LabelInput } from "@/shared/ui/molecules"
import { toast } from "@/shared/utils/toastMessage"
import { validateEmail } from "@/shared/utils/validation"
import { useRouter, useSearchParams } from "next/navigation"
import { useLocale, useTranslations } from "next-intl"
import { normalizeSafeInternalRedirect } from "@/shared/lib/safe-redirect"

const EmailSignInTemplate = () => {
  const { setLoggedIn } = useAuthContext()
  // const { connect } = useSSEContext()
  const redirectUrl = useSearchParams()?.get("redirect")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const router = useRouter()
  const locale = useLocale()
  const t = useTranslations()

  const { mutate } = useMutationSignIn({
    onSuccess:  (data) => {
      if (data) {
        setLoggedIn(true)
        // connect(data?.result?.accessToken)
        router.push(normalizeSafeInternalRedirect(redirectUrl) || `/${locale}`)
      }
    },
    onError: (error) => {
      toast.error(error.message || t("loginFailed"))
    },
  })

  const signIn = () => {
    if (email === "") {
      toast.warning(t("commonAlerts.emailRequired"))
      return
    } else if (password === "") {
      toast.warning(t("commonAlerts.passwordRequired"))
      return
    } else if (!validateEmail(email)) {
      toast.error(t("commonAlerts.emailFormatError"))
      return
    }
    mutate({ email, password })
  }

  return (
    <form className="relative flex-1 pt-4 px-4 pb-5 flex flex-col gap-5 w-full bg-white">
      <LabelInput
        type="email"
        label={t("commonForm.email")}
        placeholder={t("commonForm.emailPlaceholder")}
        value={email}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        autoComplete="email"
      />
      <LabelInput
        type="password"
        label={t("commonForm.password")}
        placeholder={t("commonForm.passwordPlaceholder")}
        value={password}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
        autoComplete="new-password"
      />
      <CustomButton className="fixed bottom-3 left-4 right-4 max-w-[600px] mx-auto h-[48px] bg-[#6B00D7] text-white rounded-lg" onClick={signIn}>
        {t("commonButtons.signIn")}
      </CustomButton>
    </form>
  )
}

export default EmailSignInTemplate
